import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from '../../../../../utils/helpers';
import './EntrantRosters.css';

const EntrantRosters = ({ entrants, myUserId }) => {
  const [activeTab, setActiveTab] = useState(myUserId);

  return (
    <div className="entrant-rosters-container">
      <h4 className="draft-board-title">ENTRANT ROSTERS</h4>
      <div className="roster-tabs">
        {entrants.map(entrant => (
          <button
            key={entrant.userId}
            className={`roster-tab ${activeTab === entrant.userId ? 'active' : ''}`}
            onClick={() => setActiveTab(entrant.userId)}
          >
            {entrant.username}
          </button>
        ))}
      </div>
      <div className="roster-content">
        {entrants.map(entrant => (
          activeTab === entrant.userId && (
            <div key={entrant.userId} className="roster-panel">
              <table className="roster-table">
                <thead>
                  <tr>
                    <th>PICK</th>
                    <th>PLAYER</th>
                    <th>CHIPS</th>
                    <th>ICM VALUE</th>
                  </tr>
                </thead>
                <tbody>
                  {entrant.team.map((player, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{player ? player.name : '-'}</td>
                      <td>{player ? formatNumber(player.sportSpecificData?.chipCount) : '-'}</td>
                      <td>{player ? `$${formatNumber(player.sportSpecificData?.icmValue)}` : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        ))}
      </div>
    </div>
  );
};

EntrantRosters.propTypes = {
  entrants: PropTypes.arrayOf(PropTypes.shape({
    userId: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    team: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      sportSpecificData: PropTypes.shape({
        chipCount: PropTypes.number,
        icmValue: PropTypes.number,
      }),
    })).isRequired,
  })).isRequired,
  myUserId: PropTypes.string.isRequired,
};

export default EntrantRosters; 